<div cdkOverlayOrigin #container>
  <ng-content></ng-content>
  <span style="margin-right: 6px;">
  </span>
  <ng-content select="dl-page-header-user-image"></ng-content>
</div>